import React, { Component } from 'react';
import { connect } from "react-redux";
import {FreeConstants} from "../../components-basic/customRoute/Endpoints/Endpoint/FreeConstants";

const ClassicCustomFieldsNotice = ({ premium }) => {
	return (
		<React.Fragment>
		{ !premium ?
      <div className="notice notice-info inline" style={{opacity: 1, display: 'block'}}>
        <p>Through the basic version you are limited to add only {FreeConstants.customFields} Custom Field. Get Pro to add unlimited custom field filters.</p>
      </div> : ''
    }
		</React.Fragment>
	)
};

export default connect( state => ({
	premium: state.premium
}))(ClassicCustomFieldsNotice);
